module.exports = __webpack_public_path__ + "img/a53029b.svg";